import { render, staticRenderFns } from "./info-footer.vue?vue&type=template&id=180e509e&scoped=true"
import script from "./info-footer.vue?vue&type=script&lang=js"
export * from "./info-footer.vue?vue&type=script&lang=js"
import style0 from "./info-footer.vue?vue&type=style&index=0&id=180e509e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e509e",
  null
  
)

export default component.exports